export default {
  setRelatedCourses(state, relatedCourses) {
    state.relatedCourses = relatedCourses;
  }
};
